import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../queryKeys';

import { DeviceConfiguration } from './types';

export function useDeviceConfigurationCache() {
  const { data } = useQuery<DeviceConfiguration>({
    queryKey: queryKeys.configuration,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  if (!data) {
    throw new Error('Device Configuration is empty. Did you forget to initRhino?');
  }

  return { configuration: data };
}
